import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-vendor-dues-overview',
  templateUrl: './vendor-dues-overview.component.html',
  styleUrl: './vendor-dues-overview.component.scss'
})
export class VendorDuesOverviewComponent{

  // #region Variables
  @Input() invoiceList: any[] = [];
  @Input() advanceList: any[] = [];
  @Input() isListView: boolean = false;
  @Input() takeAction: boolean = false;
  
  @Output() openInvoiceEvent = new EventEmitter<boolean>();
  @Output() clickSave = new EventEmitter<boolean>();
  @Output() removeInv = new EventEmitter<any>();

  showAllInvoices = false;
  showAllAdvances = false;
  maxVisible = 2;

  openInvoicePopup(){
    this.openInvoiceEvent.emit(true);
  }

  saveField(inv: any) {
    inv.editing = false;
    this.clickSave.emit(inv);
    console.log("Saved amount:", inv.amount);
  }

  deleteInvoice(inv: any) {
    console.log("Delete invoice", inv);
  }

  toggleInvoices() {
    this.showAllInvoices = !this.showAllInvoices;
  }

  toggleAdvances() {
    this.showAllAdvances = !this.showAllAdvances;
  }

  get visibleInvoices() {
    return this.showAllInvoices
      ? this.invoiceList
      : this.invoiceList?.slice(0, this.maxVisible);
  }

  get visibleAdvances() {
    return this.showAllAdvances
      ? this.advanceList
      : this.advanceList?.slice(0, this.maxVisible);
  }
}
